module.exports = __webpack_public_path__ + "static/p-service--illustTools-7c43e616db7113ca3efa11201a668077.png";